import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider.js";

const AdminOnly = (props) => {
  const { user, loading } = useAuth(); 

  if (loading) // needs the loading to not redirect when the user still isnt loaded
    return;

  if (!user || !user.isAdmin) // user not logged or user not admin
    return <Navigate to="/" />;

  return <>{props.children}</>;
};

export default AdminOnly;
